import React, { useState } from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';

import FullScreenContainer from './FullScreenContainer';
import { HeaderContent, ActionsWrapper } from './modal-elements';
import Modal from './Modal';
import { TextInput, SubmitButton, Button } from './input-elements';
import cybertwinLogo from './cybertwin_logo.png';
import { HeaderLock } from '../svg';

import eyeIcon from '../images/eyeIcon.png'; // Replace with your actual path
import eyeSlashIcon from '../images/eyeSlashIcon.png'; // Replace with your actual path 
const FormStyled = styled.form`
    margin-top: 4em;
`;

const IncorrectMessage = styled.p`
    color: ${(props) => props.theme.color.warning};
    font-weight: bold;
    opacity: ${(props) => (props.show ? 1 : 0)};
`;

const LogoContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 1em 0; /* Add space from the top and bottom */
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
`;

const BottomTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    bottom: 30px;
    left: 0;
    right: 0;
    width: 100%; /* Center the content horizontally */
    padding: 1em 0;
`;

const BlueBarText = styled.p`
    color: white;
    font-weight: bold;
    text-align: center; /* Center the text horizontally */
    font-size: 14px;
`;
const LogoImage = styled.img`
    width: 100px; // Adjust the width as needed
    height: auto;
`;

const TopBlueBar = styled.div`
    width: 100%;
    height: 3px; /* Height of the blue bar */
    background-color: #0079a1; /* Adjust the color as needed */
    display: flex;
    align-items: center;
    justify-content: center;

    padding: 0.1em 0; /* Add space from the top and bottom */
    position: absolute;
    top: 140px;
    left: 0;
    right: 0;
`;

const LoginFormWrapper = styled(FullScreenContainer)`
    position: relative;
`;

const CenteredForm = styled(FormStyled)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;

    &::after {
        content: '';
        position: absolute;
        bottom: 30px;
        left: 0;
        width: 100%;
        height: 100px; /* Height of the blue line */
        background-color: #0079a1; /* Adjust the color as needed */
    }
`;


function LoginForm(props) {
    const {
        handleSuccess,
        showStandardLogin,
        showVerifyModal,
        userVerifed,
        showForgotPasswordModal,
        userForgotComplete,
        userClickForgotPasswordLink
    } = props;

    // this variable stores whether the user has entered a correct password or not
    const [incorrectLogin, setIncorrectLogin] = useState(false);
    // this state stores the on/off value of the submit button
    const [submitDisabled, setSubmitDisabled] = useState(true);
    // this variable stores the hide/unhide values of the password input toggle button
    const [passwordVisible, setPasswordVisible] = useState(false);

    function onForgotPassChange(event) {

        const urlParams = new URLSearchParams(window.location.search);
        const forgotKeyQuery = urlParams.get('forgotpassword')
        const enteredUser = event.target.username.value;
        ///console.log("forgotKey user: " + forgotKeyQuery);
        // send password and username to api and retrieve space and role information
        fetch('https://cybertwin3login-ctdzg7dfbve8fhbp.ukwest-01.azurewebsites.net/verifyForgotPassLink', {

            headers: {
                "Link": forgotKeyQuery,
                'Content-type': 'application/json; charset=utf-8'
            },
        }).then(response => {

            if (response.ok) {
                response.json().then(
                    json => {
                        ///console.log(json);
                        const obj = json;
                        const myJSON = JSON.stringify(obj);
                        ///console.log(myJSON);
                        const myObj = JSON.parse(myJSON);
                        const email = myObj['email'];
                        if (enteredUser === email) {
                            ///console.log("Response is OK.... : " + email);
                            userForgotComplete(true);
                            setIncorrectLogin(false);
                        }
                        else {
                            ///console.log("Response Not OK.... : " + email);
                            userForgotComplete(false);
                            setIncorrectLogin(true);
                        }

                    })
            }
            else {
                userForgotComplete(false);
                setIncorrectLogin(true);
            }
        }

        )
        event.preventDefault();

    }


    function onVerify(event) {

        const urlParams = new URLSearchParams(window.location.search);
        const verKeyQuery = urlParams.get('ver')
        const enteredUser = event.target.username.value;
        ///console.log("verifying user: " + verKeyQuery);
        // send password and username to api and retrieve space and role information
        fetch('https://cybertwin3login-ctdzg7dfbve8fhbp.ukwest-01.azurewebsites.net/verificationkey', {

            headers: {
                "VerificationKey": verKeyQuery,
                'Content-type': 'application/json; charset=utf-8'
            },
        }).then(response => {

            if (response.ok) {
                response.json().then(
                    json => {
                        ///console.log(json);
                        const obj = json;
                        const myJSON = JSON.stringify(obj);
                        ///console.log(myJSON);
                        const myObj = JSON.parse(myJSON);
                        const email = myObj['userEmail'];
                        if (enteredUser === email) {
                            ///console.log("Response is OK.... : " + email);
                            userVerifed(true);
                            setIncorrectLogin(false);
                        }
                        else {
                            ///console.log("Response Not OK.... : " + email);
                            userVerifed(false);
                            setIncorrectLogin(true);
                        }

                    })
            }
            else {
                userVerifed(false);
                setIncorrectLogin(true);
            }
        }

        )
        event.preventDefault();

    }

    function onSubmit(event) {
        const enteredPassword = event.target.password.value;
        const enteredUser = event.target.username.value;
        /////console.log("Running check...");
        // send password and username to api and retrieve space and role information
        fetch('https://cybertwin3login-ctdzg7dfbve8fhbp.ukwest-01.azurewebsites.net/login', {

            headers: {
                "UserEmail": enteredUser,
                "Password": enteredPassword,
                'Content-type': 'application/json; charset=utf-8'

            },
        }).then(response => {

            if (response.ok) {
                ///console.log("Response OK....");
                response.json().then(
                    json => {
                        ///console.log(json);
                        const obj = json;
                        const myJSON = JSON.stringify(obj);
                        ///console.log(myJSON);
                        const myObj = JSON.parse(myJSON);
                        const role = myObj['role'];
                        const id = myObj['projectID'];
                        const spaceKey = myObj['spaceKey'];
                        /////console.log("the spaceKey is: " + spaceKey);
                        const previewKey = myObj['previewKey'];
                        /////console.log("the previewKey is: " + previewKey);
                        const logoKey = myObj['logoKey'];
                        const pass = enteredPassword.toString();
                        const user = enteredUser.toString();
                        ///console.log("Succesfully authenticated : " + user + " : " + pass);
                        // ///console.log("User role is :" + myObj['role'] + "| ID is :" + myObj['projectID']); 
                        setIncorrectLogin(false);
                        handleSuccess(user, pass, id, role, spaceKey, logoKey, previewKey);
                    })
            }
            else {
                ///console.log("Response Not OK....");
                setIncorrectLogin(true);
            }
        }

        )

        /////console.log("Login");
        event.preventDefault();

    }

    // When the user presses the eye beside the username, the username inpu is hidden/unhidden
    const togglePasswordVisibility = () => {
        setPasswordVisible((prevVisible) => !prevVisible);
    };


    // Handles the submit button vis
    const handleSubmitButtonVisibility = (evt) => {
        if (evt.target.value.length <= 0 && evt.target.value.length <= 0) {
            setSubmitDisabled(true);
        }
        else {
            setSubmitDisabled(false);
        }
    };



    return (
        <LoginFormWrapper>
            <LogoContainer>
                <LogoImage src={cybertwinLogo} alt="Logo" />
            </LogoContainer>
            <TopBlueBar />
            <Modal fullWidth={true}>
                <div hidden={
                    !showStandardLogin
                }>
                    <HeaderContent title="Sign In" Icon={HeaderLock}>
                        Sign in with your username and password
                    </HeaderContent>

                    <CenteredForm onSubmit={onSubmit}>
                        <div style={{ position: 'relative', paddingBottom: "10px" }}>
                            <TextInput
                                type={true ? 'text' : 'username'}
                                required
                                name="username"
                                placeholder="Enter Username"
                                onChange={handleSubmitButtonVisibility}
                                invalid={incorrectLogin}
                                style={{
                                    paddingRight: '5px',
                                    width: "350px"
                                }}
                            />
                        </div>

                        <div style={{ position: 'relative' }}>
                            <TextInput
                                type={passwordVisible ? 'text' : 'password'}
                                required
                                name="password"
                                placeholder="Enter Password"
                                onChange={handleSubmitButtonVisibility}
                                invalid={incorrectLogin}
                                style={{
                                    paddingRight: '40px', // Add space for the icon,
                                    width: "350px"
                                }}
                            />

                            <img
                                src={passwordVisible ? eyeSlashIcon : eyeIcon}
                                alt={passwordVisible ? 'Hide' : 'Show'}
                                onClick={togglePasswordVisibility}
                                style={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer',
                                    width: '20px',
                                    height: '20px',
                                }}
                            />
                        </div>
                        <div style={{ position: 'relative' }}>
                            <IncorrectMessage show={incorrectLogin} style={{
                                paddingTop: '10px'
                            }}>
                                Incorrect Password
                            </IncorrectMessage>

                        </div>
                        <div style={{
                            position: 'relative',
                            paddingBottom: "00px"
                        }}>
                            <ActionsWrapper>
                                <Button onClick={userClickForgotPasswordLink} variant="secondary">
                                    Forgot Password?
                                </Button>
                                <SubmitButton
                                    disabled={submitDisabled}
                                    value="Submit"
                                />
                            </ActionsWrapper>
                        </div>
                    </CenteredForm>



                </div>
                <div hidden={
                    !showVerifyModal
                }>
                    <HeaderContent title="Verify" Icon={HeaderLock}>
                        Please verify the email address of your link
                    </HeaderContent>

                    <CenteredForm onSubmit={onVerify}>
                        <div style={{ position: 'relative', paddingBottom: "10px" }}>
                            <TextInput
                                type={true ? 'text' : 'username'}
                                required
                                name="username"
                                placeholder="Enter email..."
                                onChange={handleSubmitButtonVisibility}
                                invalid={incorrectLogin}
                                style={{
                                    paddingRight: '5px',
                                    width: "350px"
                                }}
                            />
                        </div><div style={{ position: 'relative' }}>
                            <IncorrectMessage show={incorrectLogin} style={{
                            }}>
                                Link has expired or doesnt exist
                            </IncorrectMessage>

                        </div>

                        <div style={{
                            position: 'relative',
                            paddingBottom: "00px"
                        }}>
                            <ActionsWrapper>
                                <SubmitButton
                                    disabled={submitDisabled}
                                    value="Verify"
                                />
                            </ActionsWrapper>
                        </div>
                    </CenteredForm>



                </div>
                <div hidden={
                    !showForgotPasswordModal
                }>
                    <HeaderContent title="Forgot Password" Icon={HeaderLock}>
                        Please verify the email address of your link
                    </HeaderContent>

                    <CenteredForm onSubmit={onForgotPassChange}>
                        <div style={{ position: 'relative', paddingBottom: "10px" }}>
                            <TextInput
                                type={true ? 'text' : 'username'}
                                required
                                name="username"
                                placeholder="Enter email..."
                                onChange={handleSubmitButtonVisibility}
                                invalid={incorrectLogin}
                                style={{
                                    paddingRight: '5px',
                                    width: "350px"
                                }}
                            />
                        </div><div style={{ position: 'relative' }}>
                            <IncorrectMessage show={incorrectLogin} style={{
                            }}>
                                Link has expired or doesnt exist
                            </IncorrectMessage>

                        </div>

                        <div style={{
                            position: 'relative',
                            paddingBottom: "00px"
                        }}>
                            <ActionsWrapper>
                                <SubmitButton
                                    disabled={submitDisabled}
                                    value="Change Password"
                                />
                            </ActionsWrapper>
                        </div>
                    </CenteredForm>



                </div>
            </Modal>
            <BottomTextContainer>
                <BlueBarText>
                    CyberTwin is a registered trademark Republic of Work, 12
                    <br />
                    South Mall, Cork, T12 RD43, Ireland Email:
                    <br />
                    info@cybertwin.com | Phone: +353 21 4917272
                </BlueBarText>
            </BottomTextContainer>
        </LoginFormWrapper>
    );
}

LoginForm.propTypes = {
    handleSuccess: propTypes.func.isRequired,
    userVerifed: propTypes.func.isRequired,
    userForgotComplete: propTypes.func.isRequired,
    showForgotPasswordModal: propTypes.bool.isRequired,
    showVerifyModal: propTypes.bool.isRequired,
    showStandardLogin: propTypes.bool.isRequired,
    userClickForgotPasswordLink: propTypes.func.isRequired
};

export default LoginForm;

